import { AddProductToWishListRequest } from '../interfaces/wish-list-update-product.interface';
import { getAddProductToWishlistsMagento } from '../../../common/constants/shop-api';
import { getAuthenticationHeaders } from '../../../common/utils/auth-utils';
import { getResponseData } from '../../../common/utils/api-utils';

export async function getAddProductToWishlistsApiCallMagento(request: AddProductToWishListRequest): Promise<any> {
  const url = getAddProductToWishlistsMagento(request.wishlistId, request.sku);

  return await getResponseData(
    new Request(url, {
      method: 'POST',
      credentials: 'include',
      headers: getAuthenticationHeaders(),
      body: JSON.stringify({
        wishlistItem: {
          comments: request.comments,
          qty: request.qty,
        },
      }),
    })
  );
}
